import BaseModel from 'models/base-model';
import { SocketClient, SOCKET_CONNECTION_TYPE } from 'socket/socketio-client';
import { NOTIFICATION_EVENT_TYPES } from 'constants/web-socket-constants';
import {
  getWebSocketNotificationType,
} from 'constants/util/web-socket-utils';
import {
  setOpmServiceStatusForBanner,
  resetOpmServiceStatusForBanner,
} from 'store/actions/opm-service-actions';
import { refreshCountriesListIfNeeded } from 'store/actions/country-list-actions';

export default class GlobalSocketModel extends BaseModel({
  client: null,
  socketHasBeenDisconnected: true,
}) {
  init(config) {
    const client = new SocketClient({
      ...config,
      socketConnectionType: SOCKET_CONNECTION_TYPE.GLOBAL,
      autoConnect: true,
    });
    return this.merge({ ...this, client, socketHasBeenDisconnected: false });
  }

  setGlobalSocketClients(dispatch) {
    if (this.client) {
      this.client.on('newMessage', (event) =>
        this.onEventHandler(event, dispatch),
      );
    }
    return this;
  }

  stopGlobalSocketConnection() {
    if (this.client) {
      this.client._closeSocketConnection();
      this.client.disconnect();
      return this.merge({ ...this, socketHasBeenDisconnected: true });
    }
    return this;
  }

  setGlobalSocketDisconnect(payload) {
    return this.merge({ ...this, socketHasBeenDisconnected: payload });
  }

  onEventHandler = async (event, dispatch) => {
    switch (getWebSocketNotificationType(event)) {
      case NOTIFICATION_EVENT_TYPES.OPM_SERVICE_DOWN:
        await dispatch(setOpmServiceStatusForBanner('DOWN'));
        break;
      case NOTIFICATION_EVENT_TYPES.OPM_SERVICE_UP:
        await dispatch(resetOpmServiceStatusForBanner());
        // Refresh countries list only if localStorage doesn't have valid country names
        await dispatch(refreshCountriesListIfNeeded());
        break;
      default:
        break;
    }
  };
}
